import type { TOC } from '@ember/component/template-only';
import { or } from 'ember-truth-helpers';
import SettingsCentralMappingDropdownsDropdownCostProfile from 'lumen/components/settings/central-mapping/dropdowns/dropdown-cost-profile';
import { TRIGGER_CENTRAL_MAPPING_VARIANTS } from 'lumen/components/settings/central-mapping/dropdowns/triggers/trigger-central-mapping';
import type { CostSettingProfile } from 'lumen/models';

interface MarketSettingsCentralMappingTablesCellsTdCostProfileSignature {
  Args: {
    column: {
      costProfiles: CostSettingProfile[];
      isReadOnly?: boolean;
      onNavigateToCostSettings: () => void;
    };
    row: {
      autoCostProfile: CostSettingProfile | null;
      costProfile: CostSettingProfile | null;
      isMixedCostProfile: boolean;
      setCostProfile: (costProfile: CostSettingProfile | null) => void;
      userCostProfile: CostSettingProfile | null;
    };
    rowMeta: {
      isSelected: boolean;
    };
  };
}

const MarketSettingsCentralMappingTablesCellsTdCostProfile: TOC<MarketSettingsCentralMappingTablesCellsTdCostProfileSignature> =
  <template>
    <div data-test-id="table-central-mapping-td-cost-profile">
      <SettingsCentralMappingDropdownsDropdownCostProfile
        @autoCostProfile={{@row.autoCostProfile}}
        @costProfile={{@row.costProfile}}
        @isMixed={{@row.isMixedCostProfile}}
        @isReadOnly={{or @column.isReadOnly @rowMeta.isSelected}}
        @isSelected={{@rowMeta.isSelected}}
        @onNavigateToCostSettings={{@column.onNavigateToCostSettings}}
        @profiles={{@column.costProfiles}}
        @setCostProfile={{@row.setCostProfile}}
        @userCostProfile={{@row.userCostProfile}}
        @variant={{TRIGGER_CENTRAL_MAPPING_VARIANTS.SUBDUED}}
      />
    </div>
  </template>;

export default MarketSettingsCentralMappingTablesCellsTdCostProfile;
